// Vendors
import $ from 'jquery';

// Helpers
import { AJAX_URL } from '../config';

(() => {
  const cookieCoopID = window.wlGlobalConfig.__coop_id;
  const hideFooterQuestion =
    parseInt(cookieCoopID) ||
    localStorage.getItem('my-coop-question-hide') ||
    localStorage.getItem('my-coop-id');
  const $footerQuestionArea = $('.footer-question');

  if (hideFooterQuestion) {
    $footerQuestionArea.hide();
  } else {
    $footerQuestionArea.show();
  }

  const $footerQuestionCloseButton = $('.footer-question__close-button');
  const $footerQuestionHidePermanently = $('.footer-question__opt-out');
  const $coopSelector = $('#coop-selector-footer');
  const $cooperSelectorSubmitBtn = $('.footer-question__submit-button');
  const injectCoops = (coops) => {
    if (!coops.length) return false;

    coops.map(({ post_title, ID }) => {
      $coopSelector.append(
        $('<option>', {
          value: ID,
          text: post_title
        })
      );
    });
  };

  // Retrieve coop list on pageload, and inject.
  $.ajax({
    method: 'POST',
    url: `${AJAX_URL}wl_get_coops`,
    data: {}
  }).done(({ data }) => injectCoops(data));

  // Select onChange handler.
  $coopSelector.on('change', () =>
    $cooperSelectorSubmitBtn.attr(
      'disabled',
      !$coopSelector.val() ? 'disabled' : false
    )
  );

  // Submit handler.
  $cooperSelectorSubmitBtn.on('click', () => {
    const coopID = $coopSelector.val();
    if (!coopID) return;

    $.ajax({
      method: 'POST',
      url: `${AJAX_URL}wl_coop_select`,
      data: { coop_id: coopID }
    }).done(() => {
      localStorage.setItem('my-coop-id', coopID);
      $cooperSelectorSubmitBtn.addClass('checked');

      setTimeout(() => {
        $footerQuestionArea.slideToggle('slow');
      }, 500);
    });
  });

  // Footer Question Hide/Show Logic
  $footerQuestionCloseButton.on('click', () => $footerQuestionArea.hide());

  $footerQuestionHidePermanently.on('click', () => {
    $footerQuestionArea.hide();
    localStorage.setItem('my-coop-question-hide', true);
  });
})();

// Footer newsletter signup logic.
(() => {
  const $newsletterSubmitBtn = $('#footer-middle__sign-up-submit-btn');
  const $userEmailInputField = $('input.footer-middle__sign-up-input');

  $userEmailInputField.on('keyup', (event) =>
    $newsletterSubmitBtn.prop('disabled', event.currentTarget.value === '')
  );

  $newsletterSubmitBtn.on('click', (event) => {
    event.preventDefault();

    const userEmail = $userEmailInputField.val();

    if (!userEmail) return;

    localStorage.setItem('newsletter-user-email', userEmail);
    window.location.href = `${window.location.protocol}//${window.location.hostname}/subscribe-to-our-newsletter/`;
  });
})();
